import { OOCanvasMenuItem } from "./oo-canvas-menu-item.model";
import { OOTimeRanges } from "./OOTimeRanges.entity";

export class OOCanvasMenuItemTimeRange {
	venueKey: number;
	canvasKey: number;
	menuItemKey: number;
	timeRangeKey: string;
	created: Date;

	OOTimeRange: OOTimeRanges;

	OOCanvasMenuItem: OOCanvasMenuItem;

	name: string;

	public constructor(init?: Partial<OOCanvasMenuItemTimeRange>) {
		Object.assign(this, init);
	}
}
